import React from 'react';
import type { Source } from '../content/site';

// Small, consistent way to cite a public source next to any figure or claim.
const SourceLink: React.FC<{ source: Source; className?: string }> = ({ source, className = '' }) => (
  <a
    href={source.url}
    target="_blank"
    rel="noopener noreferrer"
    className={`text-sm text-light-blue hover:text-primary-red underline underline-offset-2 ${className}`}
    title={`${source.title} — ${source.org}, ${source.year}`}
  >
    {source.short}
  </a>
);

export default SourceLink;
